export default function extractIdFromLink(link: string): string {
  const matches = link.match(/id(\d+)/)
  if (matches && matches.length >= 2) {
    return matches[1]
  } else {
    return ""
  }
}
